module.exports = __webpack_public_path__ + "media/images/front/products/sonimage_hs2/index-banner-8250fd715e0a497b54b55b2f16a9d7aa.jpg";